<template>
    <div class="date-change">
        <span>{{ date | shortDate }}</span>
    </div>
</template>

<script>
import Filters from '../../filters'

export default {
    filters: Filters,
    props: {
        date: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
    .date-change {
        text-align: center;

        span {
            font-size: .8rem;
            padding: .1rem .75rem;
            border-radius: 10px;
            color: #666;
            font-weight: bold;
            margin-bottom: 1rem;
            display: inline-block;
            text-transform: uppercase;
        }
    }
</style>